module.exports = __webpack_public_path__ + "media/images/icons/flags/KW-0912a761ce5f548503989c6689004021.svg";